<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import aconnectAppLogo from '@/assets/app-logo-aconnect.png';
import {
  ANDROID_STORE_URL,
  IOS_STORE_URL,
  PRODUCT_LOGO_ASSET,
  PRODUCT_LOGO_STYLE,
  PRODUCT_NAME,
} from '@/constants';

const iosUrl = IOS_STORE_URL;
const androidUrl = ANDROID_STORE_URL;
const appLogo = aconnectAppLogo;
const route = useRoute();
const redirectUrl = computed(() => {
  // カスタムURLスキーム(aconnect://)を使用してアプリを起動
  return `aconnect://${route.fullPath}`;
});
</script>

<template>
  <div class="main">
    <div class="main-header">
      <div>
        <img
          class="anews-logo"
          :src="PRODUCT_LOGO_ASSET"
          :style="PRODUCT_LOGO_STYLE"
        />
      </div>
    </div>
    <div class="main-body">
      <div class="title c-title-bold--l">アプリでもっと手軽に！</div>
      <div class="subtitle">
        <span>アプリのダウンロードすると</span
        ><span>{{ PRODUCT_NAME }}をモバイル利用できます。</span>
      </div>
      <img class="app-logo" :src="appLogo" />
      <div class="download-buttons">
        <a
          class="download-button ios"
          :href="iosUrl"
          target="_blank"
          rel="noopener noreferrer"
          ><img src="@/assets/app-download-apple.svg" /></a
        ><a
          class="download-button android"
          :href="androidUrl"
          target="_blank"
          rel="noopener noreferrer"
          ><img src="@/assets/app-download-google.png"
        /></a>
      </div>
      <div class="redirect-link">
        <a :href="redirectUrl">Aconnectアプリを開く</a>
      </div>
    </div>
    <div class="main-footer">
      <div class="main-footer-content">
        <a
          href="https://stockmark.co.jp/"
          target="_blank"
          rel="noopener noreferrer"
          ><img class="logo-stockmark" src="@/assets/logo_stockmark.png"
        /></a>
        <div class="footer-links">
          <a
            class="c-title-bold--m"
            href="https://stockmark.co.jp/terms"
            target="_blank"
            rel="noopener noreferrer"
            >利用規約</a
          ><a
            class="c-title-bold--m"
            href="https://stockmark.co.jp/privacy"
            target="_blank"
            rel="noopener noreferrer"
            >プライバシーポリシー</a
          >
        </div>
        <div class="footer-links">
          <a
            class="c-title-bold--m"
            href="https://stockmark.notion.site/Aconnect-120e3679a1b8803fb2c6f27b952d4da5"
            target="_blank"
            rel="noopener noreferrer"
            >セキュリティホワイトペーパー</a
          >
        </div>
        <div class="footer-links">
          <a
            class="c-title-bold--m"
            href="https://stockmark.co.jp/company/"
            target="_blank"
            rel="noopener noreferrer"
            >会社概要</a
          ><a
            class="c-title-bold--m"
            href="https://aconnect.stockmark.co.jp/"
            target="_blank"
            rel="noopener noreferrer"
            >{{ PRODUCT_NAME }}について</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  .main-header {
    height: $header-height;
    width: 100%;
    border-bottom: 1px solid $color-gray400;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    box-shadow: 0px 1px 5px rgba($color-gray1000, 0.25);
    img.anews-logo {
      height: 32px;
      width: auto;
    }
  }

  .main-body {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0 60px 0;

    .title {
      margin-bottom: 12px;
    }

    .subtitle {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .app-logo {
      width: 112px;
      height: 112px;
      margin: 24px 0 32px 0;
    }

    .download-buttons {
      display: flex;
      .download-button {
        width: 132px;
        height: 48px;

        img {
          height: 100%;
          width: 100%;
        }

        &.android {
          width: 162px;
          height: 48px;
          margin-left: 16px;
        }
      }
    }

    .redirect-link {
      padding-top: 40px;

      a {
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .main-footer {
    width: 100%;
    background: #ffffff;
    border-top: 1px solid $color-gray400;
    display: flex;
    justify-content: center;
    .main-footer-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;

      padding-bottom: 26px;
      img.logo-stockmark {
        height: 24px;
        width: auto;
        margin: 24px 0 8px 0;
      }

      .footer-links {
        display: flex;
        gap: 16px;
        a {
          color: $color-gray800;
        }
      }
    }
  }
}
</style>
